import {
    type Action,
    type ThunkAction,
    combineReducers,
    configureStore,
} from "@reduxjs/toolkit";
import { CoreSlice } from "./modules/CoreSlice";
import { AuthSlice } from "./modules/AuthSlice";
import { StatsSlice } from "./modules/StatsSlice";
import { ThemeSlice } from "./modules/ThemeSlice";
import { NotificationsApi } from "../modules/notifications/notificationsApi";

const rootReducer = combineReducers({
    CoreReducer: CoreSlice.reducer,
    AuthReducer: AuthSlice.reducer,
    StatsReducer: StatsSlice.reducer,
    ThemeReducer: ThemeSlice.reducer,
});

export const store = configureStore({
    reducer: {
        RootReducer: rootReducer,
        [NotificationsApi.reducerPath]: NotificationsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(NotificationsApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
